<script setup lang="ts">
defineProps<{
  name: string;
  email: string;
  qrUrl?: string;
  imageUrl?: string;
}>();

const { fixedWidthImageParams } = useImageCdn();
</script>

<template>
  <div class="wad4-ticket-card">
    <div class="wad4-ticket-card__profile">
      <img v-if="imageUrl" class="wad4-ticket-card__avatar" v-bind="fixedWidthImageParams(imageUrl, 60, 1)" :alt="name">
      <div class="wad4-ticket-card__name">{{ name }}</div>
      <div class="wad4-ticket-card__email">{{ email }}</div>
    </div>
    <img v-if="qrUrl" class="wad4-ticket-card__qr" :src="qrUrl" alt="Your event badge QR code">
  </div>
</template>

<style lang="scss">
.wad4-ticket-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $wad4-spacing-3xl;
  width: 100%;
  padding: $wad4-spacing-3xl;
  border-radius: $wad4-border-radius-lg;
  // Always white — the QR must stay scannable in dark mode too (only the modal chrome themes).
  background: #ffffff;
  color: #0d1529;
  box-shadow: $wad4-box-shadow-lg;

  &__profile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: $wad4-spacing-md;
    text-align: center;
  }

  &__avatar {
    width: 60px;
    height: 60px;
    border-radius: $wad4-border-radius-full;
  }

  &__name {
    @include text-size-mixin('md');
    font-weight: $wad4-font-weight-semi-bold;
    color: #0d1529;
  }

  &__email {
    @include text-size-mixin('sm');
    color: #3d4454;
  }

  &__qr {
    width: 180px;
    height: 180px;
  }
}
</style>
